import React from "react";
import PropTypes from "prop-types";
import {
  IconButton,
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  MenuList,
  MenuItem,
} from "@mui/material";
import MoreVert from "@mui/icons-material/MoreVert";

class CardMenu extends React.PureComponent {
  static propTypes = {
    menuItems: PropTypes.array.isRequired,
    disabled: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      menuVisible: false,
    };
    this.cardMenuRef = React.createRef();
  }

  toggleMenu = (value) => this.setState({ menuVisible: value });

  render() {
    const { menuItems, disabled } = this.props;
    const { menuVisible } = this.state;

    return (
      <>
        <IconButton
          aria-label="settings"
          onClick={() => this.toggleMenu(!menuVisible)}
          disabled={disabled}
        >
          <MoreVert aria-label="settings" ref={this.cardMenuRef} />
        </IconButton>
        <Popper
          open={menuVisible}
          anchorEl={this.cardMenuRef.current}
          transition
          disablePortal
          placement="bottom-end"
          style={{ zIndex: 3 }}
        >
          {({ TransitionProps }) => (
            <Grow
              {...TransitionProps}
              id="menu-list"
              style={{ transformOrigin: "0 0 0" }}
            >
              <Paper id="menu-list-grow">
                <ClickAwayListener onClickAway={() => this.toggleMenu(false)}>
                  <MenuList>
                    {menuItems.map((item) => (
                      <MenuItem
                        key={item.key}
                        onClick={() => {
                          this.toggleMenu(false);
                          item.onClick();
                        }}
                        disabled={item.disabled}
                      >
                        {item.text}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </>
    );
  }
}

export default CardMenu;
